import {
  Component,
  Event,
  EventEmitter,
  h,
  Host,
  Prop,
  State,
  Watch,
} from "@stencil/core";
import { fetchAppPairings } from "../../api/repository";
import { App } from "../../api/types";
import { parseCsvSlugs } from "../../lib/propParsing";

@Component({
  tag: "zapier-app-suggestions",
  styleUrl: "zapier-app-suggestions.css",
  shadow: true,
})
export class ZapierAppSuggestions {
  /** App slugs (Ex. `google-sheets`) to exclude. */
  @Prop({ reflect: true }) hide = "";

  /** Categories slugs filter (Ex. include communication and excludes email: `communication,-email` ). */
  @Prop({ reflect: true }) categories = "";

  /**
   * The ID of a `script[content-type=application/json]` containing an explicit
   * set of suggestions to load
   */
  @Prop({ reflect: true }) fromJson = "";

  /** The main app to fetch suggestions for */
  @Prop({ reflect: true }) client?: string;

  /** The number of suggestions to display */
  @Prop({ reflect: true }) limit = 10;

  @State() private loading = true;
  @State() private apps: App[] = [];
  /** Emitted when an app is selected */
  @Event() private appSelected!: EventEmitter<App | undefined>;

  componentWillLoad() {
    if (this.fromJson) {
      const el = document.getElementById(this.fromJson);
      if (el?.textContent) {
        this.apps = JSON.parse(el.textContent);
        this.loading = false;
      } else {
        throw new Error(
          `#${this.fromJson} element did not contain valid apps JSON`,
        );
      }
    } else if (this.client) {
      this.findPairs();
    }
  }

  // TODO: Multiple @Watch decorators DO NOT stack!
  @Watch("client")
  @Watch("hide")
  @Watch("categories")
  private async findPairs() {
    if (!this.client) {
      throw new Error("missing client");
    }
    try {
      this.loading = true;
      const results = await fetchAppPairings(this.client, {
        hideSlugs: parseCsvSlugs(this.hide),
        categoriesSlugs: parseCsvSlugs(this.categories),
      });
      this.apps = results;
    } finally {
      this.loading = false;
    }
  }

  render() {
    if (this.loading) {
      return (
        <Host>
          <div class="app-suggestions-host-container">
            <ul>
              {Array.from({ length: this.limit }).map(() => {
                return (
                  <li
                    aria-label="loading an app suggestion"
                    class="skeleton-app"
                  />
                );
              })}
            </ul>
            <slot />
          </div>
        </Host>
      );
    }
    const apps = this.apps.slice(0, this.limit);
    return (
      <Host>
        <div class="app-suggestions-host-container">
          <ul>
            {apps.map((app) => {
              return (
                <li>
                  <button
                    type="button"
                    class="area"
                    onClick={() => {
                      this.appSelected.emit(app);
                    }}
                  >
                    <img alt="" class="icon" src={app.images.url_32x32} />
                    {app.name}
                  </button>
                </li>
              );
            })}
          </ul>
          <slot />
        </div>
      </Host>
    );
  }
}
